export default "__VITE_ASSET__gylUsMFl__"